
import { useSelector } from "react-redux";

import { InboxPage } from "./comun/inbox/InboxPage"
import { FirstLoginPage } from "./auth/FirstLoginPage";

import { RootState } from "../store";

export const HomePage = () => {   
     
    const { restablecerContrasena } = useSelector( ( state: RootState ) => state.auth );

    return (
        <>     
            {
                restablecerContrasena
                ?
                    <FirstLoginPage />
                :     
                    <InboxPage />
            }
        </>        
    )
}
